import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Link, useSearchParams } from 'react-router-dom';
import type { Calculation as CalculationType, Worksheet } from '../../../types/worksheet';
import SchemaContainer from '../custom-worksheet-v2/SchemaContainer';

type CalculationProps = {
    calculation: CalculationType;
    worksheet: Worksheet;
};

function Calculation({ calculation, worksheet }: CalculationProps): JSX.Element {
    const [search] = useSearchParams();

    // Remove the calculationId from the URL
    search.delete('calculationId');
    return (
        <div>
            <Link to={{ pathname: '.', search: search.toString() }} className="text-sm text-gray-600 flex items-center mb-4 w-fit">
                <ArrowLeftIcon className="h-4 w-4 mr-1" /> Back to calculations
            </Link>
            <SchemaContainer worksheet={worksheet} calculation={calculation} />
        </div>
    );
}

export default Calculation;
